import { render, staticRenderFns } from "./MassCustomerCategoriesStepIdentification.vue?vue&type=template&id=302218bf&scoped=true&"
import script from "./MassCustomerCategoriesStepIdentification.vue?vue&type=script&lang=js&"
export * from "./MassCustomerCategoriesStepIdentification.vue?vue&type=script&lang=js&"
import style0 from "./MassCustomerCategoriesStepIdentification.vue?vue&type=style&index=0&id=302218bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302218bf",
  null
  
)

export default component.exports